import { toast } from '../../common_components/Toast/ToastUtils';
import XLSX from 'xlsx-js-style';
const titleStyle = {
    font: { bold: true, sz: 20, color: { rgb: '181D27' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
const columnHeaderStyle = {
    font: { bold: true, sz: 11, color: { rgb: '374151' } },
    fill: { fgColor: { rgb: 'E5E7EB' } },
    alignment: { horizontal: 'center', vertical: 'center' },
};
export function exportCreatorDirectory(rows) {
    if (!rows || !Array.isArray(rows) || rows.length === 0) {
        toast.info('No data available to export');
        return;
    }
    const formatDate = (value) => {
        if (!value)
            return '';
        try {
            const d = new Date(value);
            if (isNaN(d.getTime()))
                return '';
            return d.toLocaleDateString('en-US', {
                month: '2-digit',
                day: '2-digit',
                year: 'numeric',
            });
        }
        catch {
            return '';
        }
    };
    try {
        const header = [
            'Category',
            'Type',
            'Creator Name',
            'Creator Handle',
            'Facebook Stats',
            'Instagram Stats',
            'YouTube Stats',
            'TikTok Stats',
            'Other Stats',
            'Contact Name',
            'Contact Email',
            'Tags',
            'Primary Lead',
            'Date Added',
            'Notes',
        ];
        const toExcelValue = (val) => {
            if (val === null || val === undefined || val === '')
                return '0';
            const str = String(val).trim();
            // Force Excel to treat large numeric values as text
            if (/^\d+$/.test(str) && str.length > 11) {
                return `'${str}`;
            }
            return str;
        };
        const data = rows.map((row) => {
            const stats = row.stats || {};
            return [
                row.category || '',
                row.type || '',
                row.creator_name || '',
                row.creator_handle || '',
                toExcelValue(stats.facebook),
                toExcelValue(stats.instagram),
                toExcelValue(stats.youtube),
                toExcelValue(stats.tiktok),
                toExcelValue(stats.other),
                row.contact_name || '',
                row.contact_email || '',
                Array.isArray(row.tags) ? row.tags.join(', ') : (row.tags || ''),
                row.primary_lead_name || '--',
                formatDate(row.createdAt),
                row.notes || '',
            ];
        });
        const numCols = header.length;
        const titleRow = ['Creator Directory List', ...Array(numCols - 1).fill('')];
        const spacerRow = Array(numCols).fill('');
        const sheetData = [titleRow, spacerRow, header, ...data];
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        // Apply Styles
        if (worksheet['A1']) {
            worksheet['A1'].s = titleStyle;
        }
        worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: numCols - 1 } },
        ];
        for (let c = 0; c < numCols; c++) {
            const cellRef = XLSX.utils.encode_cell({ r: 2, c });
            if (worksheet[cellRef]) {
                worksheet[cellRef].s = columnHeaderStyle;
            }
        }
        // Set Column Widths
        const wscols = header.map(() => ({ wch: 20 }));
        worksheet['!cols'] = wscols;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Creator Directory');
        const fileName = `Creator_Directory_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    }
    catch (error) {
        console.error('Failed to export creator directory:', error);
        toast.info('Failed to export. Please try again.');
    }
}
export default exportCreatorDirectory;
